const state = {
	open: true,
}

const mutations = {
	open(state) {
		state.open = true
	},
	close(state) {
		state.open = false
	},
}

export default {
	state,
	mutations,
	namespaced: true,
}
